import { HorseRaceDataProvider } from './../../providers/horse/horse-race-data/horse-race-data';
import { WebSocketService } from './../../services/webSocketService';
import { Component, Input, Output, EventEmitter, SimpleChanges, OnChanges, ElementRef, Renderer, OnInit } from '@angular/core';
import { Message } from '../../model/Message';
import { NavController, ModalController, Platform, ActionSheetController } from 'ionic-angular';
import { GalleryModal } from 'ionic-gallery-modal';
import { FunctionType } from '../../util/Constants';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { TranslateService } from '@ngx-translate/core';
import { Util } from '../../util/Util';
import { SocialSharing } from '@ionic-native/social-sharing';
import { BrowserTab } from '@ionic-native/browser-tab';


/**
 * Generated class for the ChatComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'chat',
  templateUrl: 'chat.html'
})
export class ChatComponent implements OnChanges, OnInit {
  @Input() direction?: string = "left";
  @Input() message: Message;
  @Input() isAdmin: boolean;
  @Input() functionType?: FunctionType = FunctionType.Horse;
  @Input() topicId?: number = -1;
  @Input() isShowShareBtn: boolean = false;
  @Input() selectedTab:number;
  @Input() tipsterSelectedTab?:number;
  @Output() replyMsgClicked = new EventEmitter();
  @Output() replyBtnClicked = new EventEmitter();
  @Output() censorBtnClicked = new EventEmitter();

  FunctionType = FunctionType;
  isPublishedInRaceTips: boolean = false;
  isPackageTab: boolean = false;


  ngOnChanges(changes: SimpleChanges) {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if (this.functionType == FunctionType.Help || this.functionType == FunctionType.Football) {
      this.message.senderTipScore = -1;
    }
  }

  constructor(private navCtrl: NavController, private modalCtrl: ModalController, private iab: InAppBrowser,
    private elementRef:ElementRef, private renderer:Renderer, private platform: Platform,
    private translateService: TranslateService, private socialSharing: SocialSharing, private actionSheetCtrl: ActionSheetController,
    browserTab: BrowserTab, private webSocketService: WebSocketService, private horseRaceDataProvider: HorseRaceDataProvider) {
  this.renderer.listen(this.elementRef.nativeElement, 'click', (event) => {
    if (event != null && event.target != null && event.target.nodeName != null && event.target.nodeName == "A") {
      for (let attribute of event.target.attributes) {
        if (attribute.name == "customhref") {
          if (browserTab.isAvailable() && Util.isApp(this.platform)) {
            browserTab.openUrl(attribute.value);
          } else {
            this.goToWeb(attribute.value);
          }
        }
      }
    }
  });
  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    if (this.selectedTab == 0) {
      console.log("Message: ", this.message);
      if (this.message.tipPublished) {
        this.isPackageTab = true;
      }
      if (this.message.alPublishedTipRace != null) {
        let activeRaceNum = this.horseRaceDataProvider.getActiveRaceNum();
        let raceId = this.horseRaceDataProvider.getRaceId(activeRaceNum);
        console.log("activeRaceNum: " + activeRaceNum + " || " + "raceId: " + raceId);

        let alPublishedTipRace: Array<string> = this.message.alPublishedTipRace;
        for (let info of alPublishedTipRace) {
          let s = info.split("+");
          let sTipRaceId = s[0];
          if (sTipRaceId == String(raceId)) {
            this.isPublishedInRaceTips = true;
            break;
          }
        }
      }
    }
  }

  replyMsgOnClick() {
    this.replyMsgClicked.emit(this);
  }

  replyBtnOnClick() {
    this.replyBtnClicked.emit(this);
  }

  censorBtnOnClick(isCensored: boolean, isTempCensored: boolean) {
    this.message.censored = isCensored;
    this.message.tempCensored = isTempCensored;
    this.censorBtnClicked.emit(this);
  }

  showTipsterInfo(senderId) {
    // if (this.functionType == FunctionType.Help || this.functionType == FunctionType.Football) {
    //   this.navCtrl.push("TipsterInfoPage", {"tipsterId": senderId});
    // } else {
    //   this.navCtrl.push("HorseTipsterInfoPage", {"tipsterId": senderId, "selectedTab": this.topicId == 0 ? 1 : 0});
    // }

    if (this.tipsterSelectedTab != null) {
      this.navCtrl.push("TipsterInfoPage", {"tipsterId": senderId,"selectedTab":this.selectedTab, "tipsterSelectedTab": this.tipsterSelectedTab});
    } else {
      this.navCtrl.push("TipsterInfoPage", {"tipsterId": senderId,"selectedTab":this.selectedTab, "tipsterSelectedTab": (this.isPackageTab) ? 1 : 0});
    }
  }

  showImageModal(sImgUrl: string) {
    let photos = [{url: sImgUrl}];
    let modal = this.modalCtrl.create(GalleryModal, {
      photos: photos,
      initialSlide: 0
    });
    modal.present();
  }

  goToWeb(sUrl) {
    // let win = window.open(sUrl, '_blank');
    // win.focus();
    let target = "_blank";
    let options = "location=yes,zoom=no,toolbarposition=top";
    this.iab.create(sUrl, target, options);
  }

  share() {
    let predefinedContent = this.translateService.instant("shareForumContent", { senderName: this.message.senderName, sendTime: this.message.sendTime});
    let sharingMsg = this.message.content;
    sharingMsg += predefinedContent;

    let sharingImg = this.message.imgSrc;
    if (sharingImg == null) {
      sharingImg = "";
    }
    Util.share(this.platform, this.socialSharing, this.actionSheetCtrl, sharingImg, sharingMsg);
  }
}



// WEBPACK FOOTER //
// ./src/components/chat/chat.ts